module.exports = __webpack_public_path__ + "media/images/2_help-10014fe8806a9c11548322bbd384952a.jpg";